import { render } from "./ClickToUploadFiles.vue?vue&type=template&id=289cbba7"
import script from "./ClickToUploadFiles.vue?vue&type=script&lang=js"
export * from "./ClickToUploadFiles.vue?vue&type=script&lang=js"
script.render = render

export default script